const SCRIPT_SELECTOR = 'script[data-smartcs-widget="true"]';

let inflight: Promise<HTMLScriptElement> | null = null;

function waitForScript(script: HTMLScriptElement): Promise<HTMLScriptElement> {
  if (inflight) {
    return inflight;
  }

  inflight = new Promise((resolve, reject) => {
    script.addEventListener(
      'load',
      () => {
        script.dataset.loaded = 'true';
        inflight = null;
        resolve(script);
      },
      { once: true },
    );

    script.addEventListener(
      'error',
      () => {
        inflight = null;
        reject(new Error('Widget script load failed'));
      },
      { once: true },
    );
  });

  return inflight;
}

export function loadWidgetScript(scriptUrl: string): Promise<HTMLScriptElement> {
  const existing = document.querySelector(SCRIPT_SELECTOR) as HTMLScriptElement | null;
  if (existing) {
    if (existing.dataset.loaded === 'true') {
      return Promise.resolve(existing);
    }
    return waitForScript(existing);
  }

  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  script.dataset.smartcsWidget = 'true';
  document.body.appendChild(script);

  return waitForScript(script);
}

export function removeWidgetScript(): void {
  inflight = null;
  document.querySelector(SCRIPT_SELECTOR)?.remove();
}
